<section class="section banner">
  <div [@bannerTrigger] class="container">
    <div class="section-box-banner">
      <div class="content">
        <div>
          <!-- <h1>Hola, mi nombre es</h1> -->
          <h1>Hello! My name is</h1>
        </div>
        <div class="banner-title">
          <h2>Abdul Basit Tanveer</h2>
          <h3>React Js Developer</h3>
        </div>
        <div class="banner-description">
          <p [innerHTML]="'Banner.Description' | translate" class="mt-4"></p>
        </div>
      </div>
      <div class="div-btn-banner">
        <a
          (click)="
            analyticsService.sendAnalyticEvent(
              'click_send_mail',
              'banner',
              'email'
            )
          "
          href="mailto:basitk365@gmail.com"
          target="_black"
          class="main-btn"
        >
          {{ "Banner.ActionBtn" | translate }}
        </a>
      </div>
    </div>
  </div>
</section>
